export default {
  app: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    secretKey: process.env.REACT_APP_ENC_SECRET || '',
    defaultCountryCode: '+91'
  }
}
